export class ApiError extends Error {
  status?: number;
  code?: string;
  retryAfter?: string;
  payload?: unknown;

  constructor(
    message: string,
    status?: number,
    code?: string,
    retryAfter?: string,
    payload?: unknown,
  ) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.retryAfter = retryAfter;
    this.payload = payload;
  }
}
